module.exports = __webpack_public_path__ + "static/fire_tv-271544049811cfa8f7fd9ef65dc61874.png";